import { DateDuration } from '@internationalized/date';
import {
    CalendarGridBody,
    CalendarGridHeader,
    CalendarHeaderCell,
    CalendarGrid as RACalendarGrid,
} from 'react-aria-components';

import Text from '../../../Text/Text';
import Mode from '../../types/Mode';
import CalendarCell from '../CalendarCell/CalendarCell';

import styles from './CalendarGrid.module.css';

type CalendarGridProps = {
    offset?: DateDuration;
    selectingNewRange?: boolean;
    mode?: Mode;
    showDatesOutsideMonth?: boolean;
};

const CalendarGrid = ({
    offset,
    selectingNewRange,
    mode,
    showDatesOutsideMonth,
}: CalendarGridProps) => {
    return (
        <RACalendarGrid
            offset={offset}
            className={styles.Root}
            weekdayStyle="short"
        >
            <CalendarGridHeader>
                {(day) => (
                    <CalendarHeaderCell className={styles.HeaderCell}>
                        <Text size="small" subdued>
                            {day}
                        </Text>
                    </CalendarHeaderCell>
                )}
            </CalendarGridHeader>
            <CalendarGridBody>
                {(date) => (
                    <CalendarCell
                        date={date}
                        selectingNewRange={selectingNewRange}
                        mode={mode}
                        showDatesOutsideMonth={showDatesOutsideMonth}
                    >
                        {date.day}
                    </CalendarCell>
                )}
            </CalendarGridBody>
        </RACalendarGrid>
    );
};

export default CalendarGrid;
